import { NotificationSettingsType } from 'api/types/data';
import { useTranslation } from 'libs/i18n';

import { NotificationSettingsTableStyled } from './NotificationSettingsTable.styles';
import { useColumns } from './columns';
import { NotificationSettingsTableItem } from './types';

export const NotificationSettingsTable = () => {
  const columns = useColumns();
  const { t } = useTranslation();

  const items: NotificationSettingsTableItem[] = [
    {
      name: t('settings.notifications.types.ChangeOnboardingStatus'),
      id: NotificationSettingsType.ChangeOnboardingStatus,
    },
  ];

  return (
    <NotificationSettingsTableStyled
      hideFooter
      columns={columns}
      overlayWrapperHeight={48}
      rows={items}
    />
  );
};
